import { initCategoryLoadPost } from "./category-load-post";
import { initGlossary } from "./glossary";
import { initGallery } from "./gallery";
import { initCultureImageSlider } from "./culture-image-slider";
import { initTimeline } from "./timeline";
import { initAuthorPostList } from "./author-post-list";
import { initSingleBlog } from "./single-blog";
import { initScrollToTop } from "./scrollToTop";
import { initPortfolioFilter } from "./portfolio-filter";
import { initCustomPageScripts } from "./custom";
import { initForms, initFormSelects, initCtaFormPopups, initAjaxFormSubmission } from "./form";
import { initCustomImageUpload } from "./custom-image-upload";
import { initAuditForm } from "./audit-form";
import { initFriendlyCaptcha } from "./friendly-captcha";

/**
 * Re-initialize page-specific scripts after Barba view transitions.
 */
export const initPageModules = () => {
  initForms();
  initFormSelects();
  initCtaFormPopups();
  initAjaxFormSubmission();
  initCategoryLoadPost();
  initGlossary();
  initGallery();
  initCultureImageSlider();
  initTimeline();
  initAuthorPostList();
  initSingleBlog();
  initScrollToTop();
  initPortfolioFilter();
  initCustomImageUpload();
  initFriendlyCaptcha();
  initAuditForm();
  initCustomPageScripts();
};
